<div
  class="pu-form-container"
  [formGroup]="form()"
>
  <div
    class="pu-form-container"
    formGroupName="delivery"
  >
    <pu-simple-input
      formControlName="country"
      [isReadonly]="true"
      [label]="'deliveryForm.input.country*' | translate"
    />

    <div class="pu-form-group">
      <pu-simple-input
        formControlName="area"
        [label]="'deliveryForm.input.area*' | translate"
      />

      <pu-simple-input
        formControlName="city"
        [label]="'deliveryForm.input.city' | translate"
      />
    </div>

    <pu-simple-input
      formControlName="postOffice"
      [label]="'deliveryForm.input.postOffice*' | translate"
    />
  </div>
</div>
